<template lang="pug">
  .main
    .main_title
      graphtitle
    .main_visualarea
      .main_board
        board
        .main_bottommenu
          bottommenu(type="board")
      .main_linegraph(v-bind:class="{'main_linegraph-active': linegraph}")
        linegraphboard(v-on:close="close")

</template>
<script>
  import { mapState } from 'vuex';

  import GraphTitle from './graphtitle.vue';
  import Board from './board.vue';
  import BottomMenu from './bottommenu.vue';
  import LinegraphBoard from './linegraphboard.vue';

  export default{
    computed: {
      ...mapState([
        'selected',
      ]),
      linegraph(){
        return /linegraph/.test(this.selected.mode);
      },

    },
    methods: {
      close(){
        //console.log('close 2');
        this.$emit('close');
      }
    },
    components: {
      graphtitle: GraphTitle,
      board: Board,
      bottommenu: BottomMenu,
      linegraphboard: LinegraphBoard
    }
  }


</script>
<style lang="sass">
  .main
    height: 100%
    &_title
      height: 50px
    &_visualarea
      position: relative
      height: calc(100% - 50px)
      overflow: hidden
    &_board
      height: calc(100% - 80px)
    &_bottommenu
      position: absolute
      bottom: 0
      left: 0
      width: 100%

    &_linegraph
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      transform: translate(0, 100%)
      transition: transform .3s ease-in-out
      z-index: 999
      &-active
        transform: translate(0, 0)

</style>